import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["workshop", "capacity"]

  connect() {
    this.manuallyEditedCapacity = this.capacityTarget.value !== ""
  }

  suggestCapacity() {
    if (this.data.get("suggest") !== "true" || this.manuallyEditedCapacity) return

    const option = this.workshopTarget.options[this.workshopTarget.selectedIndex]
    this.capacityTarget.value = option ? (option.dataset.capacity || "") : ""
  }

  capacityEdited() {
    this.manuallyEditedCapacity = this.capacityTarget.value !== ""
  }
}
